import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CantidadTipoGarantiaDto } from '@models/cantidades-tipo-garantia/cantidadTipoGarantiaDto.model';
import { CreateCantidadTipoGarantiaRequest } from '@models/cantidades-tipo-garantia/createCantidadTipoGarantiaRequest.model';
import { UpdateCantidadTipoGarantiaRequest } from '@models/cantidades-tipo-garantia/updateCantidadTipoGarantiaRequest.modle';
import { CantidadesTipoGarantiaService } from '@services/cantidades-tipo-garantia/cantidades-tipo-garantia.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogCantidadTipoGarantiaComponent } from '../dialog-cantidad-tipo-garantia/dialog-cantidad-tipo-garantia.component';

@Component({
  selector: 'app-cantidades-tipo-garantia',
  templateUrl: './cantidades-tipo-garantia.component.html',
  styleUrls: ['./cantidades-tipo-garantia.component.css']
})
export class CantidadesTipoGarantiaComponent implements OnInit {

  data = false
  dataSource = new MatTableDataSource<CantidadTipoGarantiaDto>();
  obj!: undefined
  displayedColumns: string[] = [];
  detalle!: string;
  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }


  constructor(
    public dialog: MatDialog,
    private cantidadesTipoGarantiaService: CantidadesTipoGarantiaService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['tipoGarantia', 'cantidad','accion'] :
        ['tipoGarantia', 'cantidad','accion'];
    });


  }


  ngOnInit() {
    this.getAllCantidadTiposGarantia();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAllCantidadTiposGarantia() {
    this.spinner.show()
    this.cantidadesTipoGarantiaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = data
          //this.dataSource.data = data.sort((a, b) => a.tipoGarantia.descripcion.toString().localeCompare(b.tipoGarantia.descripcion.toString()))
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.snackBar.showError(error, "Error");
          this.spinner.hide()
        }
      )
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogCantidadTipoGarantiaComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event != AccionesDialog.Cancelar)
      this.getAllCantidadTiposGarantia()
    });
  }

  applyFilter(event: any) {
    if (event && event.target && event.target.value !== undefined) {
    if (event && event.target && event.target.value !== undefined) {
const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
}
  }
  }



}
